const legalFormId = "fc8f37e3-2932-4f39-98fb-e5ab17c5bfb8";

export default legalFormId;
